import React, { lazy, useEffect } from 'react'
import { Router, Route, Switch } from 'react-router-dom'
import { useSelector, shallowEqual } from "react-redux"
import { ResetCSS } from '@crystals/uikit'
import AOS from 'aos'
import GlobalStyle from './style/Global'
import Menu from './components/Menu'
import SuspenseWithChunkError from './components/SuspenseWithChunkError'
import PageLoader from './components/PageLoader'
import history from './routerHistory'
import 'aos/dist/aos.css'
import FooterSection from './views/Home/components/FooterSection'

const Home = lazy(() => import('./views/Home'))
const NotFound = lazy(() => import('./views/NotFound'))

const App: React.FC = () => {
  useEffect(() => {
    AOS.init({
      duration: 2000,
    })
  }, [])

  return (
    <Router history={history}>
      <ResetCSS />
      <GlobalStyle />
      <Menu >
        <SuspenseWithChunkError fallback={<PageLoader />}>
          <Switch>
            <Route path="/" exact component={Home} />
            <Route component={NotFound} />
          </Switch>
        </SuspenseWithChunkError>
      </Menu>
      <FooterSection />
    </Router>
  )
}

export default React.memo(App)
